export default __webpack_public_path__ + "static/media/alumisoft.16371118.svg";